export enum FormlyFieldType {
  Input = 'input',
  Textarea = 'textarea',
  Select = 'select',
  MultiCheckbox = 'multicheckbox',
  DatePicker = 'datepicker'
}

export namespace FormlyFieldType {
    export function values(): FormlyFieldType[] {
        return [
            FormlyFieldType.Input,
            FormlyFieldType.Textarea,
            FormlyFieldType.Select,
            FormlyFieldType.MultiCheckbox,
            FormlyFieldType.DatePicker
        ];
    }

    export function getLabel(type: FormlyFieldType): string {
        switch (type) {
            case FormlyFieldType.Input:
                return 'Short answer';
            case FormlyFieldType.Textarea:
                return 'Paragraph';
            case FormlyFieldType.Select:
                return 'Select one';
            case FormlyFieldType.MultiCheckbox:
                return 'Select many';
            case FormlyFieldType.DatePicker:
                return 'Date';
            default:
                return '';
        }
    }

    export function getIconAndColor(type: FormlyFieldType): string {
        switch (type) {
            case FormlyFieldType.Input:
                return 'icon-accent-blue icon-textfield';
            case FormlyFieldType.Textarea:
                return 'icon-orange icon-paragraph';
            case FormlyFieldType.Select:
                return 'icon-green icon-checkbox';
            case FormlyFieldType.MultiCheckbox:
                return 'icon-yellow icon-menu';
            case FormlyFieldType.DatePicker:
                return 'icon-red icon-calendar';
            default:
                return '';
        }
    }
}